import Crud from '../crud'
let crud = new Crud((options = {}) => {
  return `/rest/machine${(options.urlParams && options.urlParams.machineId) ? '/' + options.urlParams.machineId : ''}/loadrecipe`
})

export default {
  namespaced: true,
  state: {
    loading: false,
    data: []
  },
  getters: {
    ...crud.getters
  },
  mutations: {
    ...crud.mutations
  },
  actions: {
    ...crud.actions,
    empty: {
      root: true,
      async handler ({ commit }) {
        commit('setData', [])
      }
    }
  }
}
